module.exports = __webpack_public_path__ + "img/bv-logo.87eb3afc.svg";